import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './auth/AuthProvider'
import { ProtectedRoute } from './auth/ProtectedRoute'
import { AccountStatusGate } from './auth/AccountStatusGate'
import { ConversationProvider } from './contexts/ConversationContext'
import { LoginPage } from './auth/LoginPage'
import { LandingPage } from './pages/LandingPage'
import { PrivacyPage } from './pages/PrivacyPage'
import { TermsPage } from './pages/TermsPage'
import { OnboardingPage } from './components/onboarding/OnboardingPage'
import { AppShell } from './components/layout/AppShell'
import { ChatPage } from './components/chat/ChatPage'
import { ChatIndex } from './components/chat/ChatIndex'
import { VaultPage } from './components/vault/VaultPage'
import { AgentsPage } from './components/agents/AgentsPage'
import { ConnectorsPage } from './components/connectors/ConnectorsPage'
import { SettingsPage } from './components/settings/SettingsPage'
import { AdminProtectedRoute } from './admin/AdminProtectedRoute'
import { AdminShell } from './admin/AdminShell'
import { OverviewPage } from './admin/pages/OverviewPage'
import { CostosPage } from './admin/pages/CostosPage'
import { UsersPage } from './admin/pages/UsersPage'
import { UserDetailPage } from './admin/pages/UserDetailPage'
import { BillingPage } from './admin/pages/BillingPage'
import { AlertsPage } from './admin/pages/AlertsPage'
import { TracePage } from './admin/pages/TracePage'
import './App.css'

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          {/* Public legal pages — required by Google OAuth verification
              to be accessible without authentication. Paths match the
              links in LandingPage's auth disclaimer. */}
          <Route path="/privacidade" element={<PrivacyPage />} />
          <Route path="/termos" element={<TermsPage />} />
          <Route
            path="/onboarding"
            element={
              <ProtectedRoute>
                <AccountStatusGate>
                  <OnboardingPage />
                </AccountStatusGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <AdminProtectedRoute>
                  <AdminShell>
                    <Routes>
                      <Route path="/" element={<Navigate to="/admin/overview" replace />} />
                      <Route path="/overview" element={<OverviewPage />} />
                      <Route path="/custos" element={<CostosPage />} />
                      <Route path="/utilizadores" element={<UsersPage />} />
                      <Route path="/utilizadores/:id" element={<UserDetailPage />} />
                      <Route path="/facturacao" element={<BillingPage />} />
                      <Route path="/alertas" element={<AlertsPage />} />
                      <Route path="/trace" element={<TracePage />} />
                    </Routes>
                  </AdminShell>
                </AdminProtectedRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <AccountStatusGate>
                  <ConversationProvider>
                  <AppShell>
                    <Routes>
                      <Route path="/" element={<Navigate to="/chat" replace />} />
                      <Route path="/chat" element={<ChatIndex />} />
                      <Route path="/chat/:conversationId" element={<ChatPage />} />
                      {/* /briefing and /conhecimento dropped — chat is the
                          UI. Briefings appear as conversations in the list;
                          identity ("o que sabes de mim?") is answered in
                          chat via the get_identity_summary tool. */}
                      <Route path="/briefing" element={<Navigate to="/chat" replace />} />
                      <Route path="/conhecimento" element={<Navigate to="/chat" replace />} />
                      <Route path="/vault" element={<VaultPage />} />
                      <Route path="/vault/*" element={<VaultPage />} />
                      {/* `AgentsPage` is the internal component name; the
                          user-facing label is "Rotinas" (dropping "agente"
                          nomenclature from user surfaces — internal code
                          keeps the `Agent` model and `/api/agents/*` API). */}
                      <Route path="/rotinas" element={<AgentsPage />} />
                      {/* Backwards-compat redirect for early users / PWA
                          home-screen shortcuts pointing at the old URL. */}
                      <Route path="/agents" element={<Navigate to="/rotinas" replace />} />
                      <Route path="/connectors" element={<ConnectorsPage />} />
                      <Route path="/settings" element={<SettingsPage />} />
                    </Routes>
                  </AppShell>
                  </ConversationProvider>
                </AccountStatusGate>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
